import { useAuth } from '@/components/auth/authProvider';
import { isPalmettoFinanceUser } from '@/components/auth/RequireContractAdminUser';
import { Box, Card } from '@palmetto/palmetto-components';
import { useMemo } from 'react';

import { ProjectTransactionSort, ProjectTransactionStatus } from 'types';

import { FilterablePayoutTransactionTable } from '../FilterablePayoutTransactionTable';
import { PayoutTransactionFilterName } from '../PayoutTransactionsFilter';
import { PayoutTransactionTableColumnName } from '../PayoutTransactionTable';

export const PausedTransactions = () => {
  const { claims } = useAuth();
  const hideColumns = useMemo(() => {
    const columns: PayoutTransactionTableColumnName[] = ['projectExternalId', 'status', 'batch.batchDate'];
    if (!isPalmettoFinanceUser(claims)) {
      columns.push('payee.name');
    }
    return columns;
  }, [claims]);

  const hideFilters = useMemo(() => {
    const columns: PayoutTransactionFilterName[] = ['projectExternalId', 'status', 'batchDate'];
    if (!isPalmettoFinanceUser(claims)) {
      columns.push('payeeName');
      columns.push('payoutHold');
      columns.push('isManual');
      columns.push('payeeType');
    }
    return columns;
  }, [claims]);

  const hideSort = useMemo(() => {
    const columns: ProjectTransactionSort[] = ['batchDateAsc', 'batchDateDesc'];
    if (!isPalmettoFinanceUser(claims)) {
      columns.push('payeeNameAsc');
      columns.push('payeeNameDesc');
    }
    return columns;
  }, [claims]);

  return (
    <Card padding="xs" marginTop="0">
      <Card.Header>
        <Box direction="row" justifyContent="space-between" alignItems="center">
          <Box fontSize="xl" fontWeight="medium">
            Paused Transactions
          </Box>
        </Box>
      </Card.Header>
      <Box margin="0 lg">
        <FilterablePayoutTransactionTable
          lockedQueryFilters={{ status: ProjectTransactionStatus.paused }}
          hideColumns={hideColumns}
          hideFilters={hideFilters}
          hideSort={hideSort}
          isCompact
          showPagination
          enabledButtons={['export', 'addTransaction', 'unpause', 'addToBatch']}
        />
      </Box>
    </Card>
  );
};
